export default __webpack_public_path__ + "d13c18a38c4e50f0c3de6da0f08387d9.png";